export const benifits = [
    "Quicker sell",
    "Hassle-free process"
];

export const businesses = {
    CARS: "cars24",
    MP: "mmarketplace"
};

export const marketPlaceBaseUrl = "/marketplace/";

export const journeyStatus = {
    PITCHED: "PITCHED"
};

export const rejectionText = {
    title: "CARS24 quality checks",
    description: "At CARS24, we value the quality of our listings. Every car ad undergoes a thorough QC process before it goes live. If your ad was rejected, it may be due to one of the following reasons:"
};
